export const config = {
    baseURL: 
    // tslint:disable-next-line: strict-type-predicates
    typeof window === 'undefined' ? '' : window.location.origin,
};
